import createValidationElementUtil from '../../../create-validation-element'
import { appMessages } from '../../../../../../messages'

function isURL (value) {
  if (!value) {
    return false
  }

  const url = String(value).trim()

  if (url.length === 0) {
    return false
  }

  const pattern =
    /^(https?:\/\/)([A-Za-z0-9-]+\.)+[A-Za-z]{2,}(\/[^\s]*)?$/i

  return pattern.test(url)
}

function urlValidatorUtil (value) {
  if (!isURL(value)) {
    return createValidationElementUtil(
      'url',
      appMessages.invalid,
      { name: 'Url' }
    )
  }
  return true
}

export default urlValidatorUtil
